import styled, {css} from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import {sizingCss, spacingCss, SpacingProps} from "@irati/ui/src/global/css"
import {Body} from "@irati/ui/src/Typography"

export const RelativeCard = styled(Card)`
  ${({theme}) => css`
    position: relative;
    padding-top: ${theme.spacing.three};
`}
`

export const FlexGrowCard = styled(Card)`
  flex-grow: 1;
`

const greyImageCss = css`
  ${({theme}) => css`
    height: ${theme.spacing.seven};
    padding: ${theme.spacing.two} ${theme.spacing.four};
    background-color: ${theme.colors.utility.highlight};
    border-radius: ${theme.spacing.one};
    ${spacingCss}
  `}
`

export const Image = styled.img<SpacingProps>`
  ${greyImageCss}
`

export const ManyMore = styled(Body)`
  ${({theme}) => css`
    height: ${theme.spacing.seven};
    padding: ${theme.spacing.two} ${theme.spacing.four};
    background-color: ${theme.colors.utility.highlight};
    border-radius: ${theme.spacing.one};
    ${spacingCss}
  `}
`

export const SelectorWrapper = styled.div`
  ${({theme}) => css`
    display: flex;
    flex-wrap: wrap;
    margin: ${theme.spacing.one} 0;
  `}
`

export const UsersWrapper = styled.div`
  ${spacingCss}
  ${sizingCss}
  overflow-y: scroll;
`

export const SliderContainer = styled.div`
  ${({theme}) => css`
    position: relative;
    padding: ${theme.spacing.two} ${theme.spacing.five} ${theme.spacing.four};
    border-radius: ${theme.border.radius.large};
    background-color: ${theme.colors.utility.highlight};
    box-shadow: ${theme.shadows.low};
    .slick-slider {
      .slick-dots {
        text-align: right;
      }
    }
  `}
`

export const ArrowsWrapper = styled.div`
  ${({theme}) => css`
    position: absolute;
    height: 100%;
    width: 100%;
    > span {
      position: absolute;
      top: 30%;
      z-index: 1;
      &:first-child {
        left: -${theme.spacing.four};
      }
      &:last-child {
        right: ${theme.spacing.six};
      }
    }
  `}
`
